import type { Component } from "svelte";
import IconBookOpenVariant from '~icons/mdi/book-open-variant';
import IconCalendarStar from '~icons/mdi/calendar-star';
import IconCart from '~icons/mdi/cart';
import IconClock from '~icons/mdi/clock';
import IconFish from '~icons/mdi/fish';
import IconFlower from '~icons/mdi/flower';
import IconFoodForkDrink from '~icons/mdi/food-fork-drink';
import IconFoodHotDog from '~icons/mdi/food-hot-dog';
import IconHanger from '~icons/mdi/hanger';
import IconPalette from '~icons/mdi/palette';
import IconPineTree from '~icons/mdi/pine-tree';
import IconScissorsCutting from '~icons/mdi/scissors-cutting';
import IconStoreOutline from '~icons/mdi/store-outline';
import IconTagMultiple from '~icons/mdi/tag-multiple';
import IconTractor from '~icons/mdi/tractor';
import IconWarehouse from '~icons/mdi/warehouse';
import IconWeatherNight from '~icons/mdi/weather-night';

export enum MarketCategory {
    FARMERS_MARKET = 'FARMERS_MARKET',
    GROCERY_MARKET = 'GROCERY_MARKET',
    FOOD_HALL = 'FOOD_HALL',
    STREET_FOOD_MARKET = 'STREET_FOOD_MARKET',
    FLEA_MARKET = 'FLEA_MARKET',
    ANTIQUE_MARKET = 'ANTIQUE_MARKET',
    VINTAGE_MARKET = 'VINTAGE_MARKET',
    ART_AND_CRAFT_MARKET = 'ART_AND_CRAFT_MARKET',
    FLOWER_MARKET = 'FLOWER_MARKET',
    FISH_MARKET = 'FISH_MARKET',
    BOOK_MARKET = 'BOOK_MARKET',
    TEXTILE_MARKET = 'TEXTILE_MARKET',
    NIGHT_MARKET = 'NIGHT_MARKET',
    BAZAAR = 'BAZAAR',
    COVERED_MARKET = 'COVERED_MARKET',
    CHRISTMAS_MARKET = 'CHRISTMAS_MARKET',
    SEASONAL_MARKET = 'SEASONAL_MARKET'
}

export const MARKET_CATEGORY_LABELS: Record<MarketCategory, string> = {
    [MarketCategory.FARMERS_MARKET]: 'Farmers Market',
    [MarketCategory.GROCERY_MARKET]: 'Grocery Market',
    [MarketCategory.FOOD_HALL]: 'Food Hall',
    [MarketCategory.STREET_FOOD_MARKET]: 'Street Food Market',
    [MarketCategory.FLEA_MARKET]: 'Flea Market',
    [MarketCategory.ANTIQUE_MARKET]: 'Antique Market',
    [MarketCategory.VINTAGE_MARKET]: 'Vintage Market',
    [MarketCategory.ART_AND_CRAFT_MARKET]: 'Art & Craft Market',
    [MarketCategory.FLOWER_MARKET]: 'Flower Market',
    [MarketCategory.FISH_MARKET]: 'Fish Market',
    [MarketCategory.BOOK_MARKET]: 'Book Market',
    [MarketCategory.TEXTILE_MARKET]: 'Textile Market',
    [MarketCategory.NIGHT_MARKET]: 'Night Market',
    [MarketCategory.BAZAAR]: 'Bazaar',
    [MarketCategory.COVERED_MARKET]: 'Covered Market',
    [MarketCategory.CHRISTMAS_MARKET]: 'Christmas Market',
    [MarketCategory.SEASONAL_MARKET]: 'Seasonal Market'
};

export const MARKET_CATEGORY_ICONS: Record<MarketCategory, Component> = {
    [MarketCategory.FARMERS_MARKET]: IconTractor,
    [MarketCategory.GROCERY_MARKET]: IconCart,
    [MarketCategory.FOOD_HALL]: IconFoodForkDrink,
    [MarketCategory.STREET_FOOD_MARKET]: IconFoodHotDog,
    [MarketCategory.FLEA_MARKET]: IconTagMultiple,
    [MarketCategory.ANTIQUE_MARKET]: IconClock,
    [MarketCategory.VINTAGE_MARKET]: IconHanger,
    [MarketCategory.ART_AND_CRAFT_MARKET]: IconPalette,
    [MarketCategory.FLOWER_MARKET]: IconFlower,
    [MarketCategory.FISH_MARKET]: IconFish,
    [MarketCategory.BOOK_MARKET]: IconBookOpenVariant,
    [MarketCategory.TEXTILE_MARKET]: IconScissorsCutting,
    [MarketCategory.NIGHT_MARKET]: IconWeatherNight,
    [MarketCategory.BAZAAR]: IconStoreOutline,
    [MarketCategory.COVERED_MARKET]: IconWarehouse,
    [MarketCategory.CHRISTMAS_MARKET]: IconPineTree,
    [MarketCategory.SEASONAL_MARKET]: IconCalendarStar
};